import React, { useRef } from "react";
import PropTypes from "prop-types";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

let nextCheckboxId = 0;

const CLASS_COLORS = {
  login: "#5e1313",
  logout: "#9e2020",
  blue: "#1f78b4",
  red: "#e31a1c",
  purple: "#6a3d9a",
  green: "#33a02c",
  magenta: "#8a1167",
  orange: "#fbb034",
  lilac: "#cab2d6",
  grey: "darkgrey",
  filter: "#202020",
};

const resolveColor = (className, color) => {
  if (color) {
    return color;
  }

  if (!className) {
    return CLASS_COLORS.grey;
  }

  const key = className.replace(/^_/, "");
  return CLASS_COLORS[key] || CLASS_COLORS.grey;
};

const ColorCheckbox = ({
  className = "",
  value = false,
  disabled = false,
  title = "",
  handleChange,
  id,
  color,
  style,
}) => {
  const generatedId = useRef(`color-checkbox-${++nextCheckboxId}`).current;
  const checkboxId = id || generatedId;
  const checkboxColor = resolveColor(className, color);

  return (
    <FormControlLabel
      style={{ margin: 0, display: "flex", width: "100%", ...style }}
      control={
        <Checkbox
          id={checkboxId}
          checked={value}
          disabled={disabled}
          onChange={() => {
            if (!disabled && handleChange) {
              handleChange();
            }
          }}
          size="small"
          sx={{
            color: checkboxColor,
            "&.Mui-checked": {
              color: checkboxColor,
            },
            padding: "4px 8px",
          }}
        />
      }
      label={title}
      sx={{
        "& .MuiFormControlLabel-label": {
          fontSize: 12,
          fontWeight: 600,
        },
      }}
    />
  );
};

ColorCheckbox.propTypes = {
  className: PropTypes.string,
  value: PropTypes.bool,
  disabled: PropTypes.bool,
  title: PropTypes.node.isRequired,
  handleChange: PropTypes.func,
  id: PropTypes.string,
  color: PropTypes.string,
  style: PropTypes.object,
};

export default ColorCheckbox;
